<template>
    <div class="listmain "> 
        <h1 class="firTitle">数据概览</h1>
              
              <h3 class="sedTitle">1、概述</h3>
              <p>基于数据分析模型为开发者提供系统的技能数据,开发者可通过数据分析洞察用户行为, 指导产品迭代与运营
              </p>
              <h3 class="sedTitle">2.查看页面</h3>
              <p>用户可在技能概览-数据概览中查看技能数据表现
              </p>
               <h3 class="sedTitle">3、时效性：</h3>
              <p>所有数据在凌晨统一进行计算，即今日可查看昨日数据。
              </p>
               <h3 class="sedTitle">4、指标定义：</h3>
                <table>
                <tr>
                  <th width="150px">指标</th>
                  <th>释义/计算方法</th>
                
                </tr>
                <tr>
                  <td>总用户量</td>
                  <td>历史使用当前技能的独立用户数量（即重复用户排重）</td>
                
                </tr>
                <tr>
                  <td>总交互次数</td>
                  <td>所有用户产生的交互总次数</td>
                  
                </tr>
                 <tr>
                  <td>人均交互次数</td>
                  <td>总交互次数/总用户量</td>

                </tr>
                 <tr>
                  <td>新增用户量</td>
                  <td>当日新增使用当前技能的独立用户数量（即重复用户排重）</td>
                 
                </tr>
                 <tr>
                  <td>交互日活</td>
                  <td>当前技能当日产生的活跃总量</td>
                </tr>
                  <tr>
                  <td>交互周活</td>
                  <td>当前技能上一自然周区间内，产生的活跃总量</td> 
                </tr>

                  <tr>
                  <td>交互月活</td>
                  <td>当前技能上一自然月区间内，产生的活跃总量</td>
                  
                </tr>
                  <tr>
                  <td>次日留存量</td>
                  <td>前日活跃的用户中，昨日依然活跃的用户数量</td>   
                </tr>

                 <tr>
                  <td>次日留存率</td>
                  <td>次日留存量/前日活跃数</td>         
                </tr>
                 <tr>
                  <td>周留存量</td>
                  <td>第前八日活跃用户与昨日活跃用户交集数量
例：上周五活跃用户为100，本周五活跃用户为80，其中交集有70，那么70即周留存量</td>
                  
                </tr>
                <tr>
                  <td>周留存率</td>
                  <td>周留存量/第前八日活跃数</td>
                  
                </tr>
                <tr>
                  <td>月留存量</td>
                  <td>第前三十一日活跃用户与昨日活跃用户交集数量/前日活跃用户数
例：3月31日活跃用户为1000，3月1日活跃用户为800，其中交集有700，那么700即周留存量</td>
                  
                </tr>
                 <tr>
                  <td>月留存率</td>
                  <td>月留存量/第前三十一日活跃数</td>
                  
                </tr>
                 <tr>
                  <td>全局总时长</td>
                  <td>当日使用当前技能的总时长</td>
                </tr>
              </table>

    </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
    font-size: 14px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/xggj_sjgl.vue